'use client';

import { useEffect, useRef } from 'react';
import clsx from 'clsx';

interface ShowChats {
  chats?: {
    id: string | number;
    message: string;
    mymessage: boolean;
  }[];
}

export default function ChatBox({ chats }: ShowChats) {
  const chatContainerRef = useRef<HTMLDivElement | null>(null);

  // Auto-scroll to bottom when messages update
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [chats]);

  return (
    <div
      ref={chatContainerRef}
      className="flex flex-col max-h-[374px] flex-grow overflow-y-auto md:max-h-[478px] p-4"
    >
      {chats?.map((item) => (
        <div
          key={item.id}
          className={clsx(
            'my-2 flex',
            item.mymessage ? 'justify-end' : 'justify-start',
          )}
        >
          <p
            className={clsx(
              'inline-block rounded-full px-5 py-1 text-sm md:text-base max-w-[75%] break-words',
              item.mymessage
                ? 'bg-green-500 text-white' // Green background for sent messages
                : 'bg-gray-200 text-black', // Gray background for received messages
            )}
          >
            {item.message}
          </p>
        </div>
      ))}
    </div>
  );
}
